import type { HotfixProposal, HotfixProposalDestinationAction } from '@/types/hotfixRequests';
import type { ReleaseTag, RollbackResigningStrategy } from '@/types';

export interface RequestHotfixFormValues {
    releaseVersion: string;
    releaseName?: string;
    releaseType: 'hotfix' | 'rollback';
    baseForHotfix?: string;
    shouldCreateBranch: boolean;
    shouldBumpVersionOnBranch: boolean;
    commitHashes?: string[];
    sourceVersion?: string;
    resigningStrategy: RollbackResigningStrategy;
    shouldMatchPreviousPhasedRelease: boolean;
    allDestinations: boolean;
    destinationAction: HotfixProposalDestinationAction;
    destinationIds?: string[];
    justification: string;
    formFields?: Record<string, string>;
}
export const validateJustification = async (_rule: unknown, value?: string): Promise<void> => {
    if (!value?.trim()) throw new Error('Justification is required');
};
export const validateProposalVersion = async (version: string): Promise<void> => {
    if (
        !/^v?\d+(?:\.\d+){0,2}(?:-[0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*)?(?:\+[0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*)?$/.test(
            version?.trim(),
        )
    ) {
        throw new Error('Enter a valid semantic version');
    }
};
export function buildHotfixProposal(
    values: RequestHotfixFormValues,
    bases: ReleaseTag[],
    isStaticBranch: boolean,
    canCherryPick: boolean,
    canMatchPhasedRelease: boolean,
): HotfixProposal {
    const isHotfix = values.releaseType === 'hotfix';
    return {
        releaseType: values.releaseType,
        proposedVersion: values.releaseVersion.trim(),
        ...(values.releaseName?.trim() ? { releaseName: values.releaseName.trim() } : {}),
        ...(isHotfix && !isStaticBranch && values.baseForHotfix ?
            { base: bases.find((base) => base.name === values.baseForHotfix) }
        :   {}),
        shouldCreateBranch: isHotfix && !isStaticBranch && !!values.shouldCreateBranch,
        shouldBumpVersionOnBranch: isHotfix && !!values.shouldBumpVersionOnBranch,
        commitsToCherryPick: isHotfix && canCherryPick ? (values.commitHashes ?? []) : [],
        ...(!isHotfix ?
            { rollbackSourceVersion: values.sourceVersion?.trim(), rollbackResigningStrategy: values.resigningStrategy }
        :   {}),
        shouldMatchPreviousPhasedRelease:
            isHotfix && canMatchPhasedRelease && !!values.shouldMatchPreviousPhasedRelease,
        ...(!values.allDestinations && values.destinationIds?.length ?
            {
                destinationOptions: { action: values.destinationAction, destinationIds: values.destinationIds },
            }
        :   {}),
    };
}
